import {forwardRef, useImperativeHandle} from "react";
import PositiveFeedbackModal from "./PositiveFeedbackModal";
import useModalSetup from "../../../../../../../hooks/useModalSetup";

export const PositiveFeedbackEntry = forwardRef(({}, ref) => {
    const {handleOpenModal, handleCloseModal, openModal} = useModalSetup();

    useImperativeHandle(ref, () => ({
        open() {
            handleOpenModal();
        }
    }));

    return(
        <PositiveFeedbackModal
            title={'Positive feedback'}
            open={openModal}
            handleClose={handleCloseModal}
        />
    )
});